import { accountNamespacePrefix, getActiveAccountId, namespaceKey, } from '#pplx/frontend/browser-storage/activeAccount.js';
export const LOCAL_STORAGE_KEYS = {
    threadListSectionExpansionDisabled: 'pplx.thread-list.section-expansion.disabled',
    computerDashboardSectionExpansion: 'pplx.computer-dashboard.section-expansion.v1',
    automationsDashboardSectionExpansion: 'pplx.automations-dashboard.section-expansion.v1',
};
function resolveKey(key, options) {
    return options?.global ? key : namespaceKey(key);
}
export class SafeLocalStorage {
    static getItem(key, options) {
        try {
            return window.localStorage.getItem(resolveKey(key, options));
        }
        catch {
            return null;
        }
    }
    static setItem(key, value, options) {
        try {
            window.localStorage.setItem(resolveKey(key, options), value);
            return true;
        }
        catch {
            return false;
        }
    }
    static removeItem(key, options) {
        try {
            window.localStorage.removeItem(resolveKey(key, options));
            return true;
        }
        catch {
            return false;
        }
    }
    /**
     * Clears the active account's namespace by default (single-account sign-out), leaving
     * other accounts and `global` keys intact. With no active account — single-account mode,
     * or `{ global: true }` — clears the whole store (sign-out-all / full reset, as today).
     */
    static clear(options) {
        const accountId = options?.global ? null : getActiveAccountId();
        try {
            if (!accountId) {
                window.localStorage.clear();
                return true;
            }
            const prefix = accountNamespacePrefix(accountId);
            for (const key of SafeLocalStorage.keys()) {
                if (key.startsWith(prefix)) {
                    window.localStorage.removeItem(key);
                }
            }
            return true;
        }
        catch {
            return false;
        }
    }
    // keys() returns raw, un-namespaced keys (migration and scoped clear scan them).
    static keys() {
        try {
            const len = window.localStorage.length;
            const keys = [];
            for (let i = 0; i < len; i++) {
                const key = window.localStorage.key(i);
                if (key) {
                    keys.push(key);
                }
            }
            return keys;
        }
        catch {
            return [];
        }
    }
}
//# sourceMappingURL=localStorage.js.map